import { StyledExpandedEndOfRowButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';
import { useMutationWithCacheUpdate, useTableDataState } from '../../state/table-data.state';

import { SubItem } from '../../types/sub-item.types';
import activateIcon from '@ingka/ssr-icon/paths/clipboard-checkmark';
import { cloneDeep } from 'lodash';
import inactivateIcon from '@ingka/ssr-icon/paths/clipboard-strikethrough';
import set from 'lodash/set';
import styled from '@emotion/styled';

export const SingleActivateButton = ({ subItem }: { subItem: SubItem }) => {
  const buttonTooltip = () => `${subItem.active ? 'Inactivate' : 'Activate'} material`;

  const newActive = !subItem.active;
  const mutate = useMutationWithCacheUpdate(`Material successfully ${subItem.active ? 'inactivated' : 'activated'}`);

  const onClick = () => {
    const previousActive = subItem.active;
    const updated = set(cloneDeep(subItem), 'active', newActive);

    useTableDataState.setState((state) => ({
      data: state.data.map((item) => ({
        ...item,
        subItems: item.subItems?.map((s) =>
          s.id === subItem.id && s.parentId === subItem.parentId
            ? { ...s, active: newActive }
            : s
        ),
      })),
    }));

    mutate(updated, {
      onError: () => {
        useTableDataState.setState((state) => ({
          data: state.data.map((item) => ({
            ...item,
            subItems: item.subItems?.map((s) =>
              s.id === subItem.id && s.parentId === subItem.parentId
                ? { ...s, active: previousActive }
                : s
            ),
          })),
        }));
      },
    });
  };

  return (
    <StyledTooltip title={buttonTooltip()}>
      <StyledButtonDiv>
        <StyledExpandedEndOfRowButton
          ssrIcon={subItem.active ? inactivateIcon : activateIcon}
          iconOnly={true}
          small={true}
          onClick={onClick}
          disabled={false}
          type={'tertiary'}
        />
      </StyledButtonDiv>
    </StyledTooltip>
  );
};

const StyledButtonDiv = styled.div`
  padding-left: 0.5rem;
`;